import axios from 'axios';

const SPECIAL_CHARS_REGEXP = /([\:\-\_]+(.))/g;
const MOZ_HACK_REGEXP = /^moz([A-Z])/;
const camelCase = function(name) {
    return name.replace(SPECIAL_CHARS_REGEXP, function(_, separator, letter, offset) {
        return offset ? letter.toUpperCase() : letter;
    }).replace(MOZ_HACK_REGEXP, 'Moz$1');
};

let Cookie = {
    findAll: function(doc) {
        let cookies = {},
            cookiesArr = (doc || document).cookie.split(';'),
            c, i = 0,
            len = cookiesArr.length;

        for (i; i < len; i++) {
            c = cookiesArr[i];
            c = c.replace(/^\s+/, '').replace(/\s+$/, '');
            let arr = c.split('='),
                key = arr[0],
                value = null;
            let size = arr.length;
            if (size > 1) {
                value = arr.slice(1).join('');
            }
            cookies[key] = value;
        }

        return cookies;
    },

    find: function(name, _doc) {
        let cookie = null,
            list = this.findAll(_doc),
            key;

        for (key in list) {
            if (key === name) cookie = list[key];
        }

        return cookie;
    },

    create: function(name, value, time, domain) {
        let today = new Date(),
            offset = (typeof time == 'undefined') ? (1000 * 60 * 60 * 24) : (time * 1000),
            expires_at = new Date(today.getTime() + offset);

        let cookie = `${name}=${escape(value)};expires=${expires_at.toGMTString()};path=\/`;
        domain && (cookie += `;domain=${domain}`);
        document.cookie = cookie;

        return this;
    },

    destroy: function(name, cookie) {
        if (cookie = this.find(name)) {
            this.create(name, null, -1000000);
        }

        return this;
    }
};

let domAction = {
    addClass(el, cls) {
        if (!el) return;
        let curClass = el.className;
        let classes = (cls || '').split(' ');

        for (let i = 0, j = classes.length; i < j; i++) {
            let clsName = classes[i];
            if (!clsName) continue;

            if (el.classList) {
                el.classList.add(clsName);
            } else {
                if (!hasClass(el, clsName)) {
                    curClass += ' ' + clsName;
                }
            }
        }
        if (!el.classList) {
            el.className = curClass;
        }
    },

    removeClass(el, cls) {
        if (!el || !cls) return;
        let classes = cls.split(' ');
        let curClass = ' ' + el.className + ' ';

        for (let i = 0, j = classes.length; i < j; i++) {
            let clsName = classes[i];
            if (!clsName) continue;

            if (el.classList) {
                el.classList.remove(clsName);
            } else {
                if (hasClass(el, clsName)) {
                    curClass = curClass.replace(' ' + clsName + ' ', ' ');
                }
            }
        }
        if (!el.classList) {
            el.className = trim(curClass);
        }
    },

    getStyle(element, styleName) {
        if (!element || !styleName) return null;

        styleName = camelCase(styleName);
        if (styleName === 'float') {
            styleName = 'cssFloat';
        }

        try {
            let computed = document.defaultView.getComputedStyle(element, '');
            return element.style[styleName] || computed ? computed[styleName] : null;
        } catch (e) {
            return element.style[styleName];
        }
    }
};

export default {
    jsAsynCall(fnName, param, callback) {
        let _this = this;
        let args = {
            method: fnName
        };

        return new Promise(function(resolve, reject) {
            try {
                let paramStr, prefix;

                if (Object.prototype.toString.call(param) === '[object Object]') {
                    Object.assign(args, param);
                }

                if ((param === true && callback === undefined) || callback === true) {

                    prefix = _this.getRandomStr(6);
                    args.callback = 'jscallback["' + prefix + '"]';

                    window.jscallback[prefix] = function(res) {
                        let _res = JSON.parse(res);
                        // 异步请求返回失败时统一处理
                        if (_res.callstatus === 'error') {
                            reject(_res);
                            delete window.jscallback[prefix];

                            _this.capture('log', `${fnName}: ${_res.errormsg}`);
                            return;
                        }

                        resolve(_res);
                        delete window.jscallback[prefix];
                    };
                } else {
                    args.callback = '';
                }

                let excRes = window.excApi(JSON.stringify(args));
                if (excRes === false) {
                    args.callback && reject();
                }
            } catch (err) {
                reject(err);
                _this.capture('error', err);
            }
        });
    },

    clearAsynCall() {
        delete window.jscallback;
        window.jscallback = {};
    },

    getRandomStr(num) {
        let x = "qwertyuioplkjhgfdsazxcvbnm",
            tmp = "",
            timestamp = new Date().getTime();

        for (let i = 0; i < num; i++) {
            tmp += x.charAt(Math.ceil(Math.random() * 100000) % x.length);
        }

        return timestamp + tmp;
    },

    setHeight(_h = 0, base) {
        let h;

        if (window.innerHeight) {
            h = (base || window.innerHeight) - _h;
        } else if (document.body && document.body.clientHeight) {
            h = (base || document.body.clientHeight) - _h;
        }

        return h + 'px';
    },

    elemRotate(elemId, n, fn) {
        let elem = document.getElementById(elemId),
            deg = 0,
            timer;

        let startRotate = function() {
            deg += 2;

            elem.style.transform = "rotate(" + deg + "deg)";
            elem.style.webkitTransform = "rotate(" + deg + "deg)";
            elem.style.OTransform = "rotate(" + deg + "deg)";
            elem.style.MozTransform = "rotate(" + deg + "deg)";

            if (deg === n * 360) {
                clearInterval(timer);
                deg = 0;
                return true;
            }

            return false;
        };

        timer = setInterval(function() {
            let end = startRotate();
            end && fn && fn.call(null, elem);
        }, 10);
    },

    /**
     * 数组去重
     * filter 以对象某一属性进行过滤
     * 仅支持数字和字符串
     */
    unique(lists, filter) {
        if (!Array.isArray(lists)) {
            return;
        }

        let map = {};
        for (let i = 0; i < lists.length; i += 1) {
            let item = lists[i];
            if (filter) {
                item = item[filter]
            };

            if (~['number', 'string'].indexOf(typeof item) && item === item) {
                // 避免 1 和 '1' 被过滤
                // @TODO: 1 和 '1' 交替出现多个的时候没法处理
                if (item in map && item === map[item]) {
                    lists.splice(i--, 1);
                } else {
                    map[item] = item;
                }
            } else {
                lists.splice(i--, 1);
            }
        }

        return lists;
    },

    capture(type, err) {
        var _api = {
            log: 'captureMessage',
            error: 'captureException'
        };

        if (!~['log', 'error'].indexOf(type)) {
            type = 'log';
        }

        if (window.Raven) {
            window.Raven[_api[type]](err);
        } else {
            console[type](err);
        }
    },

    gaReport() {
        if (!window.ga) { return; }
        window.ga.apply(null, arguments);
    },

    getUrlParam(key) {
        let reg = new RegExp("(^|&)" + key + "=([^&]*)(&|$)", "i");
        let n = window.location.hash.indexOf('?');
        let r = window.location.hash.substr(n + 1).match(reg);
        if (r != null) return unescape(r[2]); return null;
    },

    domAction: domAction,

    Cookie: Cookie,

	//对象序列化成a=1&b=2
    serialize(obj) {
        let arr = [];

        for (let item in obj) {
            let str = item + '=' + obj[item];
            arr.push(str);
        }

        return arr.join('&');
    },

    //客户端返回的字符串数组转数组
    string2array(str) {
        str = str.replace(/^\[|\]$/g, '');

        let arr = str.split(',');
        for (var i = 0, len = arr.length; i < len; i++) {

            arr[i] = arr[i].trim().replace(/^\'|\'$/g, '');

        }

        return arr;
    },

    //客户端返回的字符串数组转对象
    // {"wdid":507025,"name":"C:/Users/ken/AppData/Roaming/Kingsoft/office6/templates/download/default/letterhead-template-8.doc","percent":"100", "deleted":"0"}
    string2obj(str) {
        var reArr = str.match(/\{[^\{\}]+\}/g);

        let objArr =[];
        if (reArr) {
            for (var i = 0; i < reArr.length; i++) {
                let str = reArr[i];
                str = str.replace(/^\{/, '').replace(/\}$/, '').replace(/\"/g, '');

                let arr = str.split(',');
                let obj = {};

                for (var j = 0; j < arr.length; j++) {
                    let strArr = arr[j].split(':');

                    if (strArr.length === 3) {
                        strArr[1] = strArr[1] + ':' + strArr[2];
                    }

                    Object.defineProperty(obj, strArr[0].trim(), {
                        value: strArr[1].trim()
                    });
                }

                objArr.push(obj);
            }
        }

        return objArr;
    },

    // 过滤文件后缀名
    filter(str) {
        return str.replace(/\.\w+$/, '');
    },

    /**
     * gdpr检测
     * @param {*} cb 
     */
    gdprCheck(cb) {
        let _this = this;
        const createGdprModal = () => {
            let gdpr = document.createElement('div');
            gdpr.setAttribute('style', 'position:fixed;top:0;left:0;right:0;bottom:0;background-color:rgba(0,0,0,.5);z-index:10;font-family:"Segoe UI"');
            let gdprHtml = `
                <div class="gdpr-modal" style="background-color:#fff;width:570px;position:absolute;left:50%;top:50%;margin-left:-285px;margin-top:-100px;border-radius:5px;box-shadow:0 0 10px 0 #666;">
                    <div class="gdpr-modal-header" style="color:#424040;font-size:16px;position:relative;padding:26px 30px 8px;">
                        <span>Pay Notice</span>
                    </div>
                    <div style="border-top:1px solid #ebebeb;padding:8px 0;margin:0 30px;font-size:16px;line-height:26px;color:#424040;">We will not collect payment information.The data will be transmitted to third-party payment platform's. Please refer to the third-party platform's privacy policy.</div>
                    <div style="text-align:right;padding:15px 30px 28px;">
                        <span id="gdprCancelBtn" style="font-size:16px;cursor:pointer;margin-right:14px;color:#8a8585;">Cancel</span>
                        <span id="gdprContinueBtn" style="height:38px;line-height:38px;display:inline-block;background-color:#70c623;font-size:16px;cursor:pointer;color:#fff;border-radius:5px;padding:0 15px;">Continue to Pay</span>
                    </div>
                </div>`;
            gdpr.innerHTML = gdprHtml;
            document.body.appendChild(gdpr);
            _this.gaReport("send", "event", "gdpr", "show");

            let gdprCancelBtn = document.getElementById('gdprCancelBtn');
            let gdprContinueBtn = document.getElementById('gdprContinueBtn');
            gdprCancelBtn.addEventListener('click', () => {
                document.body.removeChild(gdpr);
                _this.gaReport("send", "event", "gdpr", "click", "cancel");
            });
            gdprContinueBtn.addEventListener('click', () => {
                document.body.removeChild(gdpr);
                cb();
                _this.gaReport("send", "event", "gdpr", "click", "continue");
            });
        };

        if (window.AppInfo && window.AppInfo.isGdpr) {
            createGdprModal();
        } else {
            cb();
        }
    },

    /**
     * 跳转 avengate 购物车
     * @param {*} options 
     */
    goAvengateCart(options) {
        return new Promise((resolve, reject) => {
            this.gdprCheck(() => {
                let defaults = {
                    payment_type: 'avangate',
                    productId: 7,
                    couponCode: '',
                    affiliate_id: '',
                    source: 'WPS_SUBS_V12_Docer2Vip',
                    distsrc: '',
                    access: '',
                    channel: 'normal',
                    qty: 1,
                    back_ref: 'https://store.wps.com/gopremium/success'
                };
                axios.post('https://store.wps.com/api/v3/payments', Object.assign({}, defaults, options))
                    .then(res => {
                        if (res.status === 200 && res.data && res.data.code === 'ok') {
                            resolve(res.data.result);
                            this.jsAsynCall('qingOpenVipUrl', { callbackurl: res.data.result });
                        } else {
                            this.jsAsynCall('qingOpenVipUrl', { callbackurl: 'https://store.wps.com' });
                        }
                    })
                    .catch(err => {
                        console.log(err);
                        reject(err);
                    });
            });
        });
    },

    /**
     * 弹出支付框
     * @param {*} pageSource 
     */
    popupPayment(pageSource) {
        return new Promise((resolve, reject) => {
            this.jsAsynCall('popupPaymentBox', {
                pageSource: pageSource
            }, true)
                .then(() => {
                    resolve();
                })
                .catch(err => {
                    console.log(err);
                    reject(err);
                });
        });
    },

    getImageUrl(prefix, url) {
        const hasPrefix = url.indexOf('http') >= 0;
        const hasSuffix = /(\w*|\W*|[\u4e00-\u9fa5]).\.(jpg|png|webp|jpeg|gif)$/i.test(url);


        if (!hasPrefix) {
            url = prefix + url;
        }

        if (!hasSuffix) {
            url = url + '.jpg';
        }

        return url;
    },

    getDateStr(timestamp) {
        let _t = timestamp * 1000;
        let _d = new Date(_t);
        let year = _d.getFullYear();
        let month = _d.getMonth() + 1;
        month = month < 10 ? '0' + month : month;
        let date = _d.getDate();
        date = date < 10 ? '0' + date : date;
        return year + '-' + month + '-' + date;
    }

};



// WEBPACK FOOTER //
// ./app/assets/js/util.js